import { render, staticRenderFns } from "./ns-products-preview.vue?vue&type=template&id=2255173b&"
import script from "./ns-products-preview.vue?vue&type=script&lang=js&"
export * from "./ns-products-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports